import React from 'react';
import x from '../assets/x.png';
import insta from '../assets/insta.svg';
import linkedin from '../assets/linkedin.png';

const Footer = () => {
  return (
    <footer className="w-full px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 py-6 md:py-8 lg:py-10">
      <div className="max-w-screen-2xl mx-auto flex flex-col-reverse sm:flex-row justify-between items-center gap-4 sm:gap-0">
        
        {/* Text Section */}
        <div
          className=" text-center sm:text-left"
          style={{
            fontFamily: 'Bricolage Grotesque',
            fontWeight: 300,
            fontSize: '12px',
            lineHeight: '27px',
            color: 'rgba(255, 255, 255, 1)',
            letterSpacing: '1%',
          }}
        >
          <div>Terms | Privacy Policy</div>
          <div>Copyright Payan Design Studio 2025</div>
        </div>

        {/* Social Media Icons Section */}
<div className="flex gap-4 items-center">
  <a
    href="https://www.linkedin.com/company/payan-design-studio/"
    target="_blank"
    rel="noopener noreferrer"
    className="w-7 h-6 flex items-center justify-center hover:opacity-80 transition-opacity"
  >
    <img
      src={linkedin}
      alt="LinkedIn"
      className="w-7 h-6 object-contain"
    />
  </a>
  <a
    href="https://x.com/payandesign"
    target="_blank"
    rel="noopener noreferrer"
    className="w-6 h-5 mt-2 flex items-center justify-center hover:opacity-80 transition-opacity"
  >
    <img
      src={x}
      alt="X (Twitter)"
      className="w-7 h-5 object-contain"
    />
  </a>
  <a
    href="https://www.instagram.com/payan.designstudio"
    target="_blank"
    rel="noopener noreferrer"
    className="w-7 h-6 mt-2 flex items-center justify-center hover:opacity-80 transition-opacity"
  >
    <img
      src={insta}
      alt="Instagram"
      className="w-6 h-6 object-contain"
    />
  </a>
</div>
      </div>
    </footer>
  );
};

export default Footer;